export const getPath = (...routes: string[]) => {
	return routes.join('');
};
